import BtnOrSelectWithPills from './btn_or_select_with_pills';

export default BtnOrSelectWithPills;
